import React from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Laptop,
    Plus,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";

const ITSupport = () => {
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"IT Support"}
                    icon={Laptop}
                    description={"Technical assistance and troubleshooting"}
                    color={"teal"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Submit New IT Support Ticket"
                            description="Describe your technical issue and our IT team will assist you"
                            label="New Ticket" 
                            btnClass="ticket btn-ticket blue" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <SupportTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display="2"
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display="2" 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display="65%" 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};
export default ITSupport;